import { render, staticRenderFns } from "./MatchStatsList.vue?vue&type=template&id=225e7d20"
import script from "./MatchStatsList.vue?vue&type=script&lang=js"
export * from "./MatchStatsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports